import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
const container = document.getElementById("app");
if (container) {
    const root = createRoot(container);
    root.render(_jsx(App, {}));
}
